"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INPUT_TYPE_TIME = exports.INPUT_TYPE_TEXTAREA = exports.INPUT_TYPE_TEXT = exports.INPUT_TYPE_RADIOBUTTON = exports.INPUT_TYPE_PASSWORD = exports.INPUT_TYPE_NUMBER = exports.INPUT_TYPE_DATE = exports.INPUT_TYPE_CHECKBOX = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _random = _interopRequireDefault(require("lodash/random"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
var _AuPropTypes = require("../../AuPropTypes");
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _context, _context2, _context3, _context4, _context5;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "au_input-module__container___Cquz8",
  "input": "au_input-module__input___t_bCo",
  "clear": "au_input-module__clear___srTcD",
  "modified": "au_input-module__modified___GlCMt",
  "new": "au_input-module__new___uGDC6",
  "invalid": "au_input-module__invalid___j2KMk",
  "password": "au_input-module__password___hp_j_",
  "padded": "au_input-module__padded___GTLln",
  "error": "au_input-module__error___gSgUi",
  "arrow_btn": "au_input-module__arrow_btn___cdrkU",
  "arrow_up_btn": "au_input-module__arrow_up_btn___summk au_input-module__arrow_btn___cdrkU",
  "arrow_down_btn": "au_input-module__arrow_down_btn___XZi5s au_input-module__arrow_btn___cdrkU",
  "disabled": "au_input-module__disabled___oERtl",
  "disable_up_button": "au_input-module__disable_up_button___x54DF",
  "disable_down_button": "au_input-module__disable_down_button___ioh4G"
};
const INPUT_TYPE_TEXT = 'text';
exports.INPUT_TYPE_TEXT = INPUT_TYPE_TEXT;
const INPUT_TYPE_TEXTAREA = 'textarea';
exports.INPUT_TYPE_TEXTAREA = INPUT_TYPE_TEXTAREA;
const INPUT_TYPE_PASSWORD = 'password';
exports.INPUT_TYPE_PASSWORD = INPUT_TYPE_PASSWORD;
const INPUT_TYPE_CHECKBOX = 'checkbox';
exports.INPUT_TYPE_CHECKBOX = INPUT_TYPE_CHECKBOX;
const INPUT_TYPE_RADIOBUTTON = 'radio';
exports.INPUT_TYPE_RADIOBUTTON = INPUT_TYPE_RADIOBUTTON;
const INPUT_TYPE_DATE = 'date';
exports.INPUT_TYPE_DATE = INPUT_TYPE_DATE;
const INPUT_TYPE_TIME = 'time';
exports.INPUT_TYPE_TIME = INPUT_TYPE_TIME;
const INPUT_TYPE_NUMBER = 'number';
exports.INPUT_TYPE_NUMBER = INPUT_TYPE_NUMBER;
class AuInput extends _AuComponent.default {
  static types = [INPUT_TYPE_TEXT, INPUT_TYPE_PASSWORD, INPUT_TYPE_DATE, INPUT_TYPE_TIME, INPUT_TYPE_TEXTAREA, INPUT_TYPE_CHECKBOX, INPUT_TYPE_RADIOBUTTON, INPUT_TYPE_NUMBER];
  static propTypes = {
    ..._AuPropTypes.AuInputProps,
    type: T.oneOf(AuInput.types)
  };
  static defaultProps = {
    type: INPUT_TYPE_TEXT,
    placeholder: '',
    showClear: true,
    modified: false,
    onMount: _constants.NOOP,
    onClick: _constants.NOOP,
    onChange: _constants.NOOP,
    onClear: _constants.NOOP,
    onKeyDown: _constants.NOOP,
    onKeyUp: _constants.NOOP,
    onFocus: _constants.NOOP,
    onBlur: _constants.NOOP
  };
  inputRef = /*#__PURE__*/_react.default.createRef();
  state = {
    id: `${this.props.name}_${(0, _random.default)(0, 999999)}`,
    type: this.props.type,
    name: this.props.name,
    style: this.props.style,
    autoComplete: 'off',
    autoCapitalize: 'none',
    defaultValue: this.props.defaultValue,
    readOnly: this.props.readOnly,
    maxLength: this.props.maxLength || '',
    onClick: this.props.onClick,
    onChange: this.props.onChange,
    onKeyDown: this.props.onKeyDown,
    onKeyUp: this.props.onKeyUp,
    onFocus: this.props.onFocus,
    onBlur: this.props.onBlur,
    tabIndex: this.props.tabIndex,
    min: this.props.min,
    max: this.props.max
  };
  componentDidMount() {
    this.props.onMount(this.inputRef.current);
    if (this.props.autoFocus) {
      this.inputRef.current.focus();
    }
  }
  focus = (0, _bind.default)(_context = this.focus).call(_context, this);
  focus() {
    this.inputRef.current.focus();
  }
  togglePasswordField = (0, _bind.default)(_context2 = this.togglePasswordField).call(_context2, this);
  togglePasswordField() {
    this.setState(({
      type: prevType
    }) => ({
      type: prevType === INPUT_TYPE_PASSWORD ? INPUT_TYPE_TEXT : INPUT_TYPE_PASSWORD
    }));
  }
  onClearBtnClick = (0, _bind.default)(_context3 = this.onClearBtnClick).call(_context3, this);
  onClearBtnClick(e) {
    e.preventDefault();
    this.props.onClear(e);
    this.focus();
  }
  arrowUpClick = (0, _bind.default)(_context4 = this.arrowUpClick).call(_context4, this);
  arrowUpClick() {
    this.inputRef.current.stepUp();
    this.inputRef.current.value = this.inputRef.current.value++;
    this.props.onChange(this.inputRef.current.value);
  }
  arrowDownClick = (0, _bind.default)(_context5 = this.arrowDownClick).call(_context5, this);
  arrowDownClick() {
    this.inputRef.current.stepDown();
    this.inputRef.current.value = this.inputRef.current.value--;
    this.props.onChange(this.inputRef.current.value);
  }
  render() {
    var _context7;
    const {
      createMode: newSpec,
      showClear,
      showError,
      error,
      intl,
      errorClassName
    } = this.props;
    const {
      type,
      value,
      disabled,
      modified,
      placeholderId,
      placeholder,
      min,
      max
    } = this.props;
    const errorSpec = showError && !(0, _isEmpty.default)(error) && error;
    let showLabel = false;
    const className = (0, _classnames.default)(styles.input, {
      [styles.invalid]: showError,
      [styles.new]: !showError && newSpec,
      [styles.modified]: !showError && !newSpec && modified,
      [styles.password]: this.props.type === INPUT_TYPE_PASSWORD
    });
    const showEyeBtn = type === INPUT_TYPE_PASSWORD;
    const showClearBtn = type === INPUT_TYPE_TEXT && !this.props.readOnly && !disabled && showClear;
    let Input;
    let props;
    if (type === INPUT_TYPE_TEXTAREA) {
      Input = 'textarea';
      props = (0, _assign.default)({}, (0, _omit.default)(this.state, ['type']), {
        readOnly: disabled,
        className,
        value
      });
    } else {
      var _context6;
      Input = 'input';
      props = (0, _assign.default)({}, this.state, {
        disabled,
        className,
        value
      });
      if ((0, _includes.default)(_context6 = [INPUT_TYPE_CHECKBOX, INPUT_TYPE_RADIOBUTTON]).call(_context6, type)) {
        props['checked'] = this.props.checked;
        showLabel = true;
      }
    }
    if (props && (0, _includes.default)(_context7 = [INPUT_TYPE_TEXT, INPUT_TYPE_PASSWORD, INPUT_TYPE_TEXTAREA]).call(_context7, type)) {
      props['placeholder'] = placeholderId ? intl.formatMessage({
        id: placeholderId
      }) : placeholder;
      if (this.props.autoFocus) {
        props['autoFocus'] = true;
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, this.props.className, {
        [styles.padded]: showClearBtn,
        [styles.invalid]: showError,
        [styles.disabled]: disabled
      })
    }, type === INPUT_TYPE_NUMBER && /*#__PURE__*/_react.default.createElement("button", {
      onClick: !disabled ? this.arrowUpClick : _constants.NOOP,
      className: (0, _classnames.default)(styles.arrow_up_btn, {
        [styles.disable_up_button]: value >= max,
        [styles.disabled]: disabled
      })
    }), /*#__PURE__*/_react.default.createElement(Input, (0, _extends2.default)({
      ref: this.inputRef,
      required: true
    }, props)), type === INPUT_TYPE_NUMBER && /*#__PURE__*/_react.default.createElement("button", {
      onClick: !disabled ? this.arrowDownClick : _constants.NOOP,
      className: (0, _classnames.default)(styles.arrow_down_btn, {
        [styles.disable_down_button]: value <= min,
        [styles.disabled]: disabled
      })
    }), showEyeBtn && /*#__PURE__*/_react.default.createElement("i", {
      className: `icon-eye${this.state.type === INPUT_TYPE_PASSWORD ? '' : '-slash'}`,
      onClick: this.togglePasswordField
    }), showClearBtn && /*#__PURE__*/_react.default.createElement("button", {
      "data-testid": "clearButton",
      type: "button",
      className: styles.clear,
      onClick: this.onClearBtnClick
    }), showLabel && /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: this.state.id
    }, this.props.caption || value || this.props.defaultValue), errorSpec && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.error, errorClassName),
      displayId: errorSpec.errDisplayId,
      values: {
        ...(0, _values.default)(errorSpec),
        field: intl.formatMessage({
          id: errorSpec.fieldDisplayId
        })
      },
      tag: "div"
    }));
  }
}
var _default = (0, _reactIntl.injectIntl)(AuInput, {
  forwardRef: true
});
exports.default = _default;